/* This is supposed to be a generic guard that can be called as an intermediate
   step before executing an action that cannot be undone without superUser action(s)
   in a database. This was deloped for use with GetFirstLoginOnly and is called by
   that component. */
import React                                    from 'react'
import {
   Button,
   Card,
   CardActions,
   CardContent,
   Grid,
   Typography
}                                               from '@material-ui/core'
import PropTypes                                from 'prop-types'

const ActionWarning = ( { actionText, cancelAction, continueAction, height, width } ) => {

   return(
      <Grid>
         <Card variant='outlined' style={{ height: `${height}px`, width: `${width}px` }} >
            <CardContent>
               <CardActions>
                  <Grid container >
                     <Grid item xs={12}>
                        <Typography data-testid='DeleteWarning-header-text'>
                           { actionText }
                        </Typography>
                     </Grid>
                     <Grid container style={{margin: '1rem'}} >
                        <Grid item xs={6}>
                           <Button
                              color='primary'
                              onClick={ () => { cancelAction() } }
                              data-testid='DeleteWarning-cancel-button'
                              variant='contained'
                           >
                              <Typography data-testid='DeleteWarning-cancel-button-text'>
                                 Cancel
                              </Typography>
                           </Button>
                        </Grid>
                        <Grid item xs={6}>
                           <Button
                              color='secondary'
                              onClick={continueAction}
                              data-testid='DeleteWarning-delete-button'
                              variant='contained'
                           >
                              <Typography ata-testid='DeleteWarning-delete-button-text'>
                                 Continue
                              </Typography>
                           </Button>
                        </Grid>
                     </Grid>
                  </Grid>
               </CardActions>
            </CardContent>
         </Card>
      </Grid>
   )
}

ActionWarning.propTypes = {
   actionText:                                  PropTypes.string,
   cancelAction:                                PropTypes.func,
   continueAction:                              PropTypes.func,
   height:                                      PropTypes.number,
   width:                                       PropTypes.number
}

export default ActionWarning
